<a class="twitter-timeline"
    data-height="500"
    data-width="400"
    data-tweet-limit="5"
    data-chrome="noheader"
    href="https://twitter.com/{{profile}}?ref_src=twsrc%5Etfw"
><span [innerHTML]="'SB_Tweets_By' | translate"></span> {{profile}}</a> 
